import { useQuickMenuStore } from "@/store/useQuickMenuStore";

/**
 * 자주찾는 메뉴 띠의 접기/펼치기. 접어 둔 상태는 스토어에 저장되어 새로고침해도
 * 그대로다(브라우저마다 따로).
 */
export function useQuickMenuFold() {
  const collapsed = useQuickMenuStore((state) => state.collapsed);
  const setCollapsed = useQuickMenuStore((state) => state.setCollapsed);

  return { isOpen: !collapsed, toggle: () => setCollapsed(!collapsed) };
}
